/* unplugin-vue-components disabled */import script from "./prompt.vue?vue&type=script&setup=true&lang=js"
export * from "./prompt.vue?vue&type=script&setup=true&lang=js"

import "./prompt.vue?vue&type=style&index=0&id=34b2c409&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b2c409"]])

export default __exports__